import React, { useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Box, styled, Container, Typography, Grid } from "@mui/material";
import { useSelector } from "react-redux";

import { CustomCounterAppBar } from '../../components/CustomCounterAppBar'

const RootStyle = styled(Box)(({ theme }) => ({
  backgroundColor: "#FFF",
  minHeight: "calc(100vh - 120px)",
  margin: "0px auto",
  position: "relative",
  display: "flex",
  flexDirection: "column",
  maxHeight: '100vh',
  width: "100%",
}));

const OutletWrapper = styled(Box)(({ theme }) => ({
  margin: "0px",
  backgroundColor: "#FFF",
  width: "100%",
  minHeight: "calc(100vh - 70px)",
  padding: "0.2em 0.5em",
  overflowY: "auto",
  [theme.breakpoints.down(1200)]: {
    margin: "0px",
    padding: "0.2em 0.5em",
  },
  [theme.breakpoints.down("sm")]: {
    margin: "0px",
    padding: "0.2em 0.5em",
  },
  [theme.breakpoints.down("xs")]: {
    margin: "0px",
    padding: "0.2em 0.5em",
  },
}));

const ContainerPrincipal = styled(Grid)(({ theme }) => ({
  margin: "0px 45px 0px 0px",
  display: 'grid !important',
  gridTemplateColumns: '20% 60% 20%',
  gridAutoRows: '100vh !important',
  overflowY: 'hidden !important',
  '&::-webkit-scrollbar': {
    width: '0',
    background: 'transparent',
  },
  overflowX: 'hidden',
  position: 'fixed',
  top: 0,
  bottom: 0,
  width: '100%',
  [theme.breakpoints.only('xs')]: {
    gridTemplateColumns: '100%',
  },
  [theme.breakpoints.only('sm')]: {
    gridTemplateColumns: '10% 80% 10%',
  },
  [theme.breakpoints.only('md')]: {
    gridTemplateColumns: '15% 70% 15%',
  },
  [theme.breakpoints.only('lg')]: {
    gridTemplateColumns: '20% 60% 20%',
  },
  [theme.breakpoints.only('xl')]: {
    gridTemplateColumns: '20% 60% 20%',
  },
  background: "#f1f1f1"
}));

const LateralBox = styled(Box)(({ theme }) => ({
  background: "#f2f2f2",
  [theme.breakpoints.only('xs')]: {
    display: 'none'
  },
  [theme.breakpoints.only('sm')]: {
    display: 'block !important'
  },
  [theme.breakpoints.only('md')]: {
    display: 'block !important'
  },
  [theme.breakpoints.only('lg')]: {
    display: 'block !important'
  },
  [theme.breakpoints.only('xl')]: {
    display: 'block !important'
  },
}));


export const HomeLayout = () => {
  const auth = useSelector(state => state)

  // console.log('REDUX', auth)

  return (
    <ContainerPrincipal>
      <LateralBox />
      <RootStyle>
        <CustomCounterAppBar />
        <OutletWrapper>
          <Outlet />
        </OutletWrapper>
      </RootStyle>
      <LateralBox />
    </ContainerPrincipal>
  );
};
